import type { HelpFile } from '../../types/help'
import { IdentityStepTestIds } from '../../../testids/IdentityStepTestIds'

export const identityStepHelp: HelpFile = {
  docPage: '/docs/onboarding/identity-step',
  texts: {
    [IdentityStepTestIds.btnAddIdentifier]: 'Add another identifier (e.g. email, employee ID) to the identity being onboarded.',
    [IdentityStepTestIds.cardTitleExistingIdentifiers]: 'Identifiers already linked to this party — use these to recognize duplicates.',
    [IdentityStepTestIds.cardTitleExistingIdentities]: 'Existing identities for this party — pick one to extend instead of creating a duplicate.',
    [IdentityStepTestIds.cardTitleIdentifiers]: 'Identifiers that uniquely reference this identity in source systems.',
    [IdentityStepTestIds.cardTitleIdentityAttributes]: 'Identity-specific attributes such as job title, department, or location.',
    [IdentityStepTestIds.cardTitleIdentityDetails]: 'Core identity details: type, validity dates, and primary identifier.',
    [IdentityStepTestIds.inputEntryDate]: 'The date this identity becomes active. Provisioning will not happen before this date.',
    [IdentityStepTestIds.inputExitDate]: 'The date this identity is automatically deactivated. Leave blank for no expiry.',
    [IdentityStepTestIds.selectIdentityType]: 'Pick the kind of identity being onboarded — for example employee, contractor, or service.',
  },
}
